<h1 class="mat-h1" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{ title }}
</h1>
<mat-dialog-content>
  <mat-card class="mb-1">
    <mat-card-content>
      <app-empresas-detail [params]="data.empresa">
      </app-empresas-detail>
    </mat-card-content>
  </mat-card>
</mat-dialog-content>
<mat-dialog-actions class="row">
  <button (click)="onAcept()" class="col btn-submit" mat-raised-button>
    {{ aceptText }}
  </button>
</mat-dialog-actions>
